import JsonApiResource from './decorators/json-api-resource.decorator';
import JsonApiProperty from './decorators/json-api-property.decorator';
import JsonApiRelationship from './decorators/json-api-relationship.decorator';
import useAtomicOperations from './hooks/use-atomic-operations';
import entityManager from './entity-manager';
import { JsonApiProvider } from './components/jsonapi-provider';
import { BaseEntity } from './base-entity';
import { AtomicOperation } from './atomic-operation';
import { type AtomicResult } from './types';

export * from 'jsonapi-react';

const getSchema = entityManager.generateSchema;

export {
  JsonApiResource,
  JsonApiProperty,
  JsonApiRelationship,
  useAtomicOperations,
  getSchema,
  JsonApiProvider,
  BaseEntity,
  AtomicOperation,
  type AtomicResult,
};
